<template>
  <div class="editable-ticket">
    <TicketDetail
      class="editable-ticket__ticket"
      :link-url="linkUrl"
      :image-url="imageUrl"
      :item-id="itemId"
      :item-name="itemName"
      :item-sku-id="itemSkuId"
      :item-sku-name="itemSkuName"
      :brand-name="brandName"
      :expired-date="expiredDate"
      :price="price"
      :is-ticket-disabled="false"
      :is-including-tax="isIncludingTax"
    />
    <div class="editable-ticket__actions">
      <div class="editable-ticket__actions--delete" @click="clickDeleteButton">
        削除
      </div>
      <div class="editable-ticket__actions--quantity">
        <p class="quantity__label">
          枚数
        </p>
        <div class="quantity__actions">
          <span
            :class="{
              'quantity__btn--minus': !isMinusBtnActive,
              'quantity__btn--minus--active': isMinusBtnActive
            }"
            @click="countDown"
          />
          <span class="quantity__action--number">
            {{ quantity }}
          </span>
          <span
            :class="{
              'quantity__btn--plus': !isPlusBtnActive,
              'quantity__btn--plus--active': isPlusBtnActive
            }"
            @click="countUp"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TicketDetail from '../../atoms/tickets/TicketDetail.vue'

export default {
  components: {
    TicketDetail
  },
  props: {
    linkUrl: {
      type: String,
      required: false,
      default: ''
    },
    imageUrl: {
      type: String,
      required: true
    },
    itemId: {
      type: Number,
      required: false,
      default: null
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuId: {
      type: Number,
      required: false,
      default: null
    },
    itemSkuName: {
      type: String,
      required: false,
      default: ''
    },
    brandName: {
      type: String,
      required: true
    },
    expiredDate: {
      type: String,
      required: true
    },
    price: {
      type: Number,
      required: true
    },
    isTicketDisabled: {
      type: Boolean,
      required: true
    },
    isIncludingTax: {
      type: Boolean,
      required: true
    },
    quantity: {
      type: Number,
      required: true
    },
    isPlusBtnActive: {
      type: Boolean,
      required: true
    },
    isMinusBtnActive: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    countUp() {
      this.$emit('click-count-up', this.itemSkuId)
    },
    countDown() {
      this.$emit('click-count-down', this.itemSkuId)
    },
    clickDeleteButton() {
      this.$emit('click-delete-button', this.itemSkuId)
    }
  }
}
</script>

<style lang="scss" scoped>
.editable-ticket {
  &__ticket {
    display: flex;
    flex-direction: column;
  }

  &__actions {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &--delete {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      height: 26px;
      padding: 0 8px;
      border-radius: 4px;
      background-color: $gray-2;
    }

    &--quantity {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .quantity {
    &__label {
      font-size: 1.6rem;
      color: $black;
      margin-right: 24px;
    }

    &__actions {
      display: flex;
      align-items: center;
    }

    &__action {
      &--number {
        min-width: 64px;
        font-size: 1.6rem;
        line-height: 1.6;
        max-width: 30px;
        text-align: center;
      }
    }

    &__btn {
      &--minus {
        cursor: pointer;
        background-position: top 50% left 50%;
        border-radius: 50%;
        box-sizing: border-box;
        padding-left: 32px;
        height: 32px;

        @include bg-settings(
          '../../../../../images/icons/white-minus.svg',
          $gray-2,
          16px,
          16px
        );
        cursor: default;

        &--active {
          cursor: pointer;
          background-position: top 50% left 50%;
          border-radius: 50%;
          box-sizing: border-box;
          padding-left: 32px;
          height: 32px;

          @include bg-settings(
            '../../../../../images/icons/white-minus.svg',
            $black,
            16px,
            16px
          );
        }
      }

      &--plus {
        cursor: pointer;
        background-position: top 50% left 50%;
        border-radius: 50%;
        box-sizing: border-box;
        padding-left: 32px;
        height: 32px;
        @include bg-settings(
          '../../../../../images/icons/white-plus.svg',
          $gray-2,
          16px,
          16px
        );
        cursor: default;

        &--active {
          cursor: pointer;
          background-position: top 50% left 50%;
          border-radius: 50%;
          box-sizing: border-box;
          padding-left: 32px;
          height: 32px;

          @include bg-settings(
            '../../../../../images/icons/white-plus.svg',
            $black,
            16px,
            16px
          );
        }
      }
    }
  }
}
</style>
